import type { Alert } from '../hooks/useAlerts'
export const PRODUCT_TYPES = [
  { value: 'flower', label: 'Flower' }, { value: 'pre_roll', label: 'Pre-rolls' },
  { value: 'vape', label: 'Vapes' }, { value: 'edible', label: 'Edibles' },
  { value: 'concentrate', label: 'Concentrates' }, { value: 'beverage', label: 'Beverages' },
  { value: 'tincture', label: 'Tinctures' }, { value: 'topical', label: 'Topicals' }, { value: 'other', label: 'Other / not specified' },
] as const
export type TodaySort = 'impact' | 'newest' | 'brand' | 'product_type'
export interface TodayView {
  version: 1; brands: string[]; productTypes: string[]; sort: TodaySort
  locationId: string | null; actionType: 'all' | 'price' | 'promo' | 'catalog'; tab: 'open' | 'done' | 'all'
}
export const STANDARD_TODAY_VIEW: TodayView = { version: 1, brands: [], productTypes: [], sort: 'impact', locationId: null, actionType: 'all', tab: 'open' }
export const SORT_OPTIONS = [{ value: 'impact', label: 'Highest impact' }, { value: 'newest', label: 'Newest first' }, { value: 'brand', label: 'Brand A–Z' }, { value: 'product_type', label: 'Product type A–Z' }]
export function productType(category: string | null | undefined): string {
  const c = (category ?? '').trim().toLowerCase()
  if (['flower','indica','sativa','hybrid'].includes(c)) return 'flower'
  if (['pre-roll','pre-rolls','preroll','prerolls','pre roll','pre rolls'].includes(c)) return 'pre_roll'
  if (['vape','vapes','vaporizer','vaporizers','cartridge','cartridges','pod','pods','disposable','disposables'].includes(c)) return 'vape'
  if (['edible','edibles','gummy','gummies','chocolate','chocolates'].includes(c)) return 'edible'
  if (['concentrate','concentrates','extract','extracts','wax','hash','rosin','resin'].includes(c)) return 'concentrate'
  if (['drink','drinks','beverage','beverages'].includes(c)) return 'beverage'
  if (['tincture','tinctures'].includes(c)) return 'tincture'
  if (['topical','topicals'].includes(c)) return 'topical'
  return 'other'
}
export function matchesProductView(alert: Alert, brands: string[], types: string[]): boolean {
  return (!brands.length || brands.includes((alert.entity_brand ?? '').trim().toLowerCase())) &&
    (!types.length || types.includes(productType(alert.entity_category)))
}
export function sameTodayView(a: TodayView, b: TodayView): boolean {
  const canonical = (view: TodayView) => [view.version, [...view.brands].sort(), [...view.productTypes].sort(), view.sort, view.locationId, view.actionType, view.tab]
  return JSON.stringify(canonical(a)) === JSON.stringify(canonical(b))
}
